<template>
  <v-layout fill-height row wrap mx-4>
    <v-flex xs12>
      <!-- Title -->
      <v-layout
        row
        wrap
        class="overflow-x-hidden pr-3 mt-0"
        style="line-height: 20px; word-wrap: break-word"
      >
        <h4
          style="font-size: 18px"
          @click="$router.push(`/feed/${itemData.feedId}`)"
          :class="`hover-underline colorBlack1`"
        >
          {{
            itemData.Content
              ? itemData.Content.length > 150
                ? itemData.Content.substring(0, 149) + "..."
                : itemData.Content
              : ""
          }}
        </h4>
      </v-layout>

      <!-- users -->

      <v-layout
        row
        wrap
        class="mt-2 pr-3 Black"
        style="line-height: 18px; font-size: 15px"
      >
        <!-- <span
            :class="index !== 0 ? 'ml-3 light-blue--text' : 'light-blue--text'"
            v-for="(User, index) in itemData.RelatedUsers"
            :key="index"
            >{{ User.FullName + "&nbsp;" }}</span
          > -->

        <span
          class="mr-3 light-blue--text"
          v-for="(User, index) in [
            { FullName: 'Ahmet Çümen' },
            { FullName: 'Poyraz Çümen' },
            { FullName: 'Ezgi Çümen' },
            { FullName: 'Cengiz Çümen' },
          ]"
          :key="index"
          >{{ User.FullName + "&nbsp;" }}</span
        >
      </v-layout>

      <!-- tags -->
      <v-layout
        row
        wrap
        class="mt-2 pr-3 colorGrey3"
        style="line-height: 17px; font-size: 15px"
      >
        <!-- <span
            :class="index !== 0 ? 'ml-3' : ''"
            v-for="(tag, index) in itemData.Tags"
            :key="index"
            >{{ "#" + tag.TagName }}</span
          > -->
        <span
          class="mr-3"
          v-for="(tag, index) in [
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
            { TagName: 'etiket1' },
          ]"
          :key="index"
          >{{ "#" + tag.TagName }}</span
        >
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    itemData: Object,
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>
